"use strict";
exports.__esModule = true;
exports.propertyOf = void 0;
var propertyOf = function (name) { return name; };
exports.propertyOf = propertyOf;
//# sourceMappingURL=propertyOf.js.map